import type { HealthStatus } from '../types/tenant';

const STATUS_CONFIG: Record<HealthStatus, { color: string; label: string }> = {
  healthy: { color: '#22C55E', label: 'Healthy' },
  degraded: { color: '#FF9900', label: 'Degraded' },
  unhealthy: { color: '#EF4444', label: 'Unhealthy' },
  unknown: { color: '#ACB7C5', label: 'Unknown' },
};

interface HealthDotProps {
  status: HealthStatus;
  showLabel?: boolean;
}

export function HealthDot({ status, showLabel = true }: HealthDotProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.unknown;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: config.color,
        }}
      />
      {showLabel && <span>{config.label}</span>}
    </span>
  );
}
